module.exports = __webpack_public_path__ + "webpc/img/icon_int_2.d22914c4.png";